import {
  Button,
  Chip,
  Grid,
  Typography,
  Stack
} from "@mui/material";
import { useForm } from 'react-hook-form';
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import ProzoDataGrid from "../../../common/ProzoDataGrid";
import ChannelOrderExportButton from "./ChannelOrderExportButton";
import {
  ChannelIcon,
  formatCurrency,
  formatDate,
  formatNumber,
  maskEmail,
  PushFulfilledToShopify,
  shouldMaskData,
} from "../../../helpers/UtilityHelper";
import { useGetChannelOrderQuery } from "../../../redux/commonRTK";
import _ from "lodash";
import Loader from "../../../common/Loader";
import MUIModal from "../../../common/MUIModal";
// import { getMerchant } from "../../../helpers/ReduxHelpers";
import { getMerchant } from "../../../helpers/ReduxHelpers";

import {
  // getGeneric,
  apiConstants,
  postGeneric,
} from "../../../common/constants";
import AwbLinkCell from '../../../common/AwbLinkCell';
import { FormProvider, RHFDateRangePickerField, RHFSelectField, RHFTextField } from "../../../common/hook-form";
import { WEIGHT_FILTER_DEFAULTS, WeightRangeFields, buildWeightFilters } from './weightFilter'
import CheckCircleIcon from '@mui/icons-material/Download';
import { LoadingButton } from "@mui/lab";
import { useSelector } from "react-redux";
import jwt_decode from "jwt-decode";
import { getToken } from "../../../helpers/ReduxHelpers";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useSnackbar } from "notistack";
import { filterBarSx, primaryBtnSx, secondaryBtnSx, btnRowSx } from '../../../styles/patterns';
import { primaryTextSx, secondaryTextSx, cellStackSx, getPaymentChipSx, getStatusChipSx, awbTextSx } from './cellStyles';
import { FONT, SIZE, WEIGHT } from '../../../styles/foundation/typography';
import NetraScoreBadge from "../NetraScoreBadge";
import RtoRiskBadge from "../RtoRiskBadge";
import { netraStageNote } from "../netraStageNote";

export default function OtherChannelOrders(props) {
  const [page, setPage] = useState(0);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [orderItems, setOrderItems] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  // const [placeOrderFor, setPlaceOrderFor] = useState([]);
  // const [merchant, setMerchant] = useState(null);
  const [andFilters, setAndFilters] = useState([]);
  // The SKU / Item Name box has to match either field, so it cannot live in andfilter.
  // Backend composes {$and:[...], $or:[...]}, i.e. (all ANDs) AND (any OR).
  const [orFilters, setOrFilters] = useState([]);
  const [skuDetails, setSkuDetails] = useState([]);
  const [finalData, setFinalData] = useState([]);
  const [loading, setIsLoading] = useState(false)
  const [pushFulfilledLoading, setPushFulfilledLoading] = useState(false)
  const { status } = props;
  const { enqueueSnackbar } = useSnackbar();

  const merchant = getMerchant();
  const merchantId = merchant.id ? merchant.id : ''
  const { report } = useSelector(state => state);
  const { piiAccessAllow } = jwt_decode(getToken());

  const defaultFilters = [
    {
      "field": "proshipOrder.currentStatus",
      "operator": "in",
      "value": status
    },
    {
      "field": "merchant.$id",
      "operator": "eq",
      "value": merchantId
    },

  ]

  const methods = useForm({
    defaultValues: {
      order_number: '',
      order_name: '',
      awb_number: '',
      email: '',
      phone: '',
      awbNumber: '',
      orderConfirmationStatus: '',
      addressVerificationStatus: '',
      tagsValue: '',
      fromDate: '',
      toDate: '',
      sku: '',
      itemName: '',
      ...WEIGHT_FILTER_DEFAULTS
    }
  });


  const {
    handleSubmit,
    reset
  } = methods;

  const { data, isLoading, isFetching } = useGetChannelOrderQuery({
    andfilter: [...defaultFilters, ...andFilters],
    orfilter: [...orFilters],
    sort: { field: "createdDate", direction: "DESC" },
    offset: page * sizePerPage,
    limit: sizePerPage,
    "excludes": "sla,merchant,mappedOrderRule"
  });


  useEffect(() => {
    if (data?.data?.length > 0) {
      let skus = data?.data?.map((row) => row.orderItems);
      skus = skus.flat().map((row) => row.sku_id);
      skus = [...new Set(skus)];
      postGeneric(apiConstants.GET_SKU_DIM, { skuList: skus })
        .then((_response) => {
          setSkuDetails(_response.data);
        })
        .catch((_err) => {
          console.log(_err);
        });
    }
  }, [data]);

  useEffect(() => {
    if (data?.data?.length > 0) {
      const fData = data?.data?.map((row) => {
        const rowItems = row?.orderItems?.map((oi) => {
          const skuDetail = skuDetails?.find(
            (sku) => sku.skuCode === oi.sku_id
          );
          return { ...oi, ...skuDetail };
        });

        return { ...row, orderItems: rowItems };
      });

      setFinalData(fData);
    } else if (data?.data?.length === 0) {
      setFinalData([])
    }
  }, [skuDetails, data]);

  const applyPickupFilters = (filters) => {
    let appliedPickupFilters = [];
    // "Weight Between" (grams): checked first so an invalid range changes nothing.
    const weight = buildWeightFilters(filters)
    if (weight.error) {
      enqueueSnackbar(weight.error, { variant: 'error' })
      return
    }
    appliedPickupFilters.push(...weight.filters)
    // if (filters.order_number) {
    //   appliedPickupFilters.push({ "field": "order_number", "operator": "eq", "value": filters.order_number })
    // }
    if (filters.order_number) {
      appliedPickupFilters.push({ "field": "order_number", "operator": "in", "value": [...filters.order_number.split(',')] })
    }
    if (filters.order_name) {
      appliedPickupFilters.push({ "field": "orderName", "operator": "in", "value": [...filters.order_name.split(',')] })
    }
    if (filters.awb_number) {
      appliedPickupFilters.push({ "field": "awbNumber", "operator": "eq", "value": filters.awb_number })
    }
    if (filters.payment_mode) {
      appliedPickupFilters.push({ "field": "paymentMode", "operator": "eq", "value": filters.payment_mode })
    }
    if (filters.phone) {
      appliedPickupFilters.push({ "field": "customer.phone", "operator": "eq", "value": '+91' + filters.phone })
    }
    if (filters.email) {
      appliedPickupFilters.push({ "field": "customer.email", "operator": "eq", "value": filters.email })
    }
    if (filters.store_name) {
      appliedPickupFilters.push({ "field": "store_name", "operator": "eq", "value": filters.store_name })
    }
    if (filters.orderConfirmationStatus) {
      appliedPickupFilters.push({ "field": "orderConfirmationStatus", "operator": "eq", "value": filters.orderConfirmationStatus })
    }
    if (filters.addressVerificationStatus) {
      appliedPickupFilters.push({ "field": "addressVerificationStatus", "operator": "eq", "value": filters.addressVerificationStatus })
    }
    if (filters.awbNumber) {
      appliedPickupFilters.push({ "field": "proshipOrder.awbNumber", "operator": "eq", "value": filters.awbNumber })
    }
    if (filters.tagsValue) {
      appliedPickupFilters.push({
        "field": "tags",
        "operator": "like",
        "value": filters.tagsValue
      })
    }
    if (filters.fromDate) {
      appliedPickupFilters.push({ field: 'createdDate', operator: 'gte', value: `Date('${formatDate(filters.fromDate, 'yyyy-MM-dd')} 00:00:00')` })
    }
    if (filters.toDate) {
      appliedPickupFilters.push({ field: 'createdDate', operator: 'lte', value: `Date('${formatDate(filters.toDate, 'yyyy-MM-dd')} 23:59:59')` })
    }
    if (filters.sku) appliedPickupFilters.push({ field: 'orderItems.skuId', operator: 'eq', value: filters.sku })
    if (filters.itemName) appliedPickupFilters.push({ field: 'orderItems.title', operator: 'like', value: filters.itemName })
    setOrFilters([])
    setAndFilters(appliedPickupFilters)
    // handleAndFiltersChange(appliedPickupFilters);
  }
  // const handleAndFiltersChange = (newAndFilters) => {
  //   refetch({
  //     andfilter: [...defaultFilters, ...newAndFilters],
  //   });
  // };

  const formatOrderStatus = (status) => {
    if (!status) return '-';
    return status.replace(/_/g, ' ').toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };


  const columns = [
    {
      field: 'channel',
      sortable: false,
      flex: 0.9,
      minWidth: 120,
      hideSortIcons: true,
      headerAlign: "center",
      headerName: 'Order No',
      renderCell: (params) => {
        const { row } = params;
        return (
          <Box sx={cellStackSx}>
            <Typography sx={primaryTextSx}>{row.order_number}</Typography>
            <ChannelIcon name={row.channel} />
          </Box>
        );
      },
    },
    {
      field: "store_name",
      flex: 1,
      minWidth: 120,
      hideSortIcons: true,
      sortable: false,
      headerAlign: "left",
      headerName: "Store Name",
      renderCell: ({ row }) => {
        return (
          <Box sx={cellStackSx}>
            <Typography sx={primaryTextSx}>{row.store_name}</Typography>
          </Box>
        );
      },
    },

    {
      field: 'orderName',
      minWidth: 100,
      hideSortIcons: true,
      sortable: false,
      headerAlign: "left",
      headerName: 'Order Name',
      renderCell: ({ row }) => {
        return (
          <Box sx={cellStackSx}>
            <Typography sx={secondaryTextSx}>{row.orderName}</Typography>
          </Box>
        );
      },
    },
    {
      field: 'orderConfirmationStatus',
      sortable: false,
      flex: 1.2,
      minWidth: 130,
      hideSortIcons: true,
      headerAlign: "left",
      headerName: 'Verification',
      renderCell: (params) => {
        const { row } = params;
        return (
          <Box sx={cellStackSx}>
            <Typography sx={secondaryTextSx}>
              WA: {row?.orderConfirmationStatus ? formatOrderStatus(row?.orderConfirmationStatus) : '-'}
            </Typography>
            <Typography sx={secondaryTextSx}>
              Addr: {row?.addressVerificationStatus ? formatOrderStatus(row?.addressVerificationStatus) : '-'}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "channelOrderId",
      flex: 1,
      minWidth: 110,
      hideSortIcons: true,
      sortable: false,
      headerAlign: "left",
      headerName: "Order Details",
      renderCell: ({ row }) => {
        return (
          <Box sx={cellStackSx}>
            <Typography sx={primaryTextSx}>
              {formatDate(row.order_date, "dd MMM, yyyy")}
            </Typography>
            <Typography sx={secondaryTextSx}>
              {row.order_number}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: 'customer',
      flex: 1.1,
      minWidth: 150,
      hideSortIcons: true,
      sortable: false,
      headerAlign: "left",
      headerName: 'Customer Details',
      renderCell: ({ row }) => {
        return (
          <Box sx={cellStackSx}>
            <Typography sx={primaryTextSx}>
              {row.customer?.first_name}
            </Typography>
            <Typography sx={{ ...secondaryTextSx, wordBreak: 'break-word' }}>
              {shouldMaskData(report, row, piiAccessAllow) ? maskEmail(
                row.customer?.email
              ) : (
                row.customer?.email
              )}
            </Typography>
            {/* NETRA scores, frozen at channel-order ingest. Both badges self-hide
                when unscored or when the merchant opted out, and open the full card
                in a dialog on click — same components /orders uses. */}
            {row.netra_address && (
              <Box sx={{ mt: 0.3 }}>
                <NetraScoreBadge
                  netra={row.netra_address}
                  orderId={row.id}
                  scorePath={`channel-order/${row.id}/netra-score`}
                  scoredStageNote={netraStageNote(row.netra_address)}
                />
              </Box>
            )}
            {row.netra_rto && (
              <Box sx={{ mt: 0.3 }}>
                <RtoRiskBadge
                  netra={row.netra_rto}
                  orderId={row.id}
                  scorePath={`channel-order/${row.id}/netra-score`}
                  scoredStageNote={netraStageNote(row.netra_rto)}
                />
              </Box>
            )}
          </Box>
        );
      },
    },
    {
      field: "courierPartner",
      flex: 1,
      minWidth: 120,
      hideSortIcons: true,
      sortable: false,
      align: "left",
      headerName: "Courier Partner",
      renderCell: (params) => {
        const { row } = params;
        let proshipOrders = row.proshipOrder;
        return (
          <Box sx={cellStackSx}>
            {proshipOrders?.map((o, i) => (
              <Typography key={i} sx={secondaryTextSx}>{o?.courierDetail?.parent}</Typography>
            ))}
          </Box>
        );
      },

    },
    {
      field: "awb",
      flex: 1.2,
      minWidth: 140,
      hideSortIcons: true,
      sortable: false,
      headerAlign: "left",
      headerName: "AWB Number",
      renderCell: (params) => {
        const { row } = params;
        let proshipOrders = row.proshipOrder;
        return (
          <Box sx={cellStackSx}>
            {proshipOrders?.map((o, i) => (
              <AwbLinkCell key={i} awb={o?.awbNumber} sx={awbTextSx} extraQuery={`&verified=${row?.orderConfirmationStatus ? true : null}`} />
            ))}
          </Box>
        );
      },
    },
    {
      field: "status",
      flex: 1.2,
      minWidth: 140,
      hideSortIcons: true,
      sortable: false,
      headerAlign: "left",
      headerName: "Current Status",
      renderCell: (params) => {
        const { row } = params;
        let proshipOrders = row.proshipOrder;
        return (
          <Box sx={cellStackSx}>
            {proshipOrders?.map((o, i) => (
              <Typography key={i} sx={secondaryTextSx}>{o?.currentStatus}</Typography>
            ))}
          </Box>
        );
      },
    },
    {
      field: "items",
      flex: 0.8,
      minWidth: 80,
      hideSortIcons: true,
      sortable: false,
      headerAlign: "center",
      headerName: "Items",
      renderCell: (params) => {
        const { row } = params;
        return (
          <Button
            onClick={() => setOrderItems(row.orderItems)}
            sx={{
              fontFamily: FONT,
              fontSize: SIZE['2xs'],
              textTransform: 'none',
              p: 0,
            }}
            size="small"
          >
            View Items
          </Button>
        );
      },
    },
    {
      field: "paymentDetails",
      headerAlign: "center",
      sortable: false,
      align: "center",
      headerName: "Payment Details",
      flex: 1,
      minWidth: 110,
      hideSortIcons: true,
      renderCell: (params) => {
        const { row } = params;
        const paymentMode = row.payment_mode ? row.payment_mode : "";
        return (
          <Box sx={cellStackSx}>
            {row.total_price ? (
              <Typography sx={primaryTextSx}>
                {formatCurrency(row.total_price)}
              </Typography>
            ) : (
              ""
            )}
            <Chip
              size="small"
              sx={getPaymentChipSx(paymentMode)}
              label={paymentMode}
            />
            {row.financial_status && (
              <Chip size="small" label={row.financial_status}
                sx={{ fontFamily: FONT, fontSize: '11px', fontWeight: 600, height: 20, bgcolor: '#fff3e0', color: '#B45309', border: '1px solid #F59E0B' }} />
            )}
          </Box>
        );
      },
    },
    {
      field: 'tags',
      flex: 1.2,
      minWidth: 120,
      hideSortIcons: true,
      sortable: false,
      headerAlign: "left",
      headerName: 'Tags',
      renderCell: ({ row }) => {
        if (row.tags) {
          const tags = row.tags.split(',')
          return (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, py: 1 }}>
              {tags.map((t, i) => (
                <Chip
                  key={i}
                  size="small"
                  variant="outlined"
                  sx={{ fontSize: SIZE['2xs'], fontFamily: FONT, fontWeight: WEIGHT.semibold }}
                  label={t.trim().toUpperCase()}
                />
              ))}
            </Box>
          )
        }
      }
    },
    {
      field: "channelOrderStatus",
      headerAlign: "center",
      sortable: false,
      align: "center",
      flex: 1,
      minWidth: 110,
      hideSortIcons: true,
      headerName: "Channel Status",
      renderCell: ({ row }) => {
        const statusVal = row.channelOrderStatus ? row.channelOrderStatus.toUpperCase().replace(/\s+/g, '_') : '';
        return (
          <Chip
            size="small"
            sx={getStatusChipSx(statusVal)}
            label={_.startCase(row.channelOrderStatus)}
          />
        );
      },
    },
    // {
    //   field: "mesurements",
    //   headerAlign: "center",
    //   align: "center",
    //   sortable: false,
    //   headerName: "Channel Weight",
    //   flex: 1,
    //   renderCell: ({ row }) => {
    //     return (
    //       <Box>
    //         <Typography textAlign="center" variant="body2" fontWeight={500}>
    //           Weight: {formatNumber(row.total_weight / 1000)}Kg
    //         </Typography>
    //       </Box>
    //     );
    //   },
    // },
  ];

  const bulkCreateHandler = () => {
    const awbs = finalData.filter(fd => selectedRows.includes(fd.id)).map((R) => R?.proshipOrder?.[0]?.awbNumber)
    setIsLoading(true)
    postGeneric(apiConstants.GET_BULK_LABELS, {
      awbList: awbs
    }).then(({ data }) => {
      window.open(data.mergedPdf, true)
    }).catch(e => console.error(e))
      .finally(() => setIsLoading(false))
  };

  return (
    <div>
      {(isLoading || isFetching || loading) && <Loader />}
      <Grid item container spacing={2}>
        <Grid item xs={12}>
          <Box data-rp-filters sx={filterBarSx}>
            <FormProvider methods={methods} onSubmit={handleSubmit(applyPickupFilters)}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={6} md={3}>
                  <RHFTextField
                    name="order_number"
                    label={
                      <>
                        Order Number <Typography variant="caption">(Comma Separated)</Typography>
                      </>
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <RHFTextField
                    name="order_name"
                    label={
                      <>
                        Order Name <Typography variant="caption">(Comma Separated)</Typography>
                      </>
                    }
                  />
                </Grid>
                {/* <Grid item xs={3} >
                  <RHFTextField name="awb_number" label="AWB Number" variant="outlined" />
                </Grid> */}
                <Grid item xs={12} sm={6} md={2}>
                  <RHFSelectField
                    label="Payment Mode"
                    name="payment_mode"
                    options={[{ label: "COD", value: 'COD' }, { label: "PREPAID", value: 'PREPAID' }]}
                    width="100%"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <RHFSelectField
                    label="Whatapp Verification Status"
                    name="orderConfirmationStatus"
                    options={[
                      { label: "Not Subscribed", value: 'NOT_SUBSCRIBED' },
                      { label: "Sent", value: 'SENT' },
                      { label: "Delivered", value: 'DELIVERED' },
                      { label: "Order Confirmed", value: 'ORDER_CONFIRMED' },
                      { label: "Order Cancelled", value: 'ORDER_CANCELLED' }]}
                    width="100%"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <RHFSelectField
                    label="Address Verification Status"
                    name="addressVerificationStatus"
                    options={[
                      { label: "Not Subscribed", value: 'NOT_SUBSCRIBED' },
                      { label: "Sent", value: 'SENT' },
                      { label: "Delivered", value: 'DELIVERED' },
                      { label: "Address Updated", value: 'ADDRESS_UPDATED' },
                      { label: "No Change Required", value: 'NO_CHANGE_REQUIRED' },
                      { label: "Address Update Failed", value: 'ADDRESS_UPDATE_FAILED' }]}
                    width="100%"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <RHFTextField name="email" label="Customer Email" />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <RHFTextField name="phone" label="Customer Phone" />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <RHFTextField name="store_name" label="Store Name" />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <RHFTextField name="awbNumber" label="AWB Number" />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <RHFTextField name="tagsValue" label="Tags" />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <RHFDateRangePickerField label="Order Date" maxDate={new Date()} />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <RHFTextField name="sku" label="SKU" />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <RHFTextField name="itemName" label="Item Name" />
                </Grid>
                <WeightRangeFields />
                <Grid item xs={12}>
                  <Box sx={btnRowSx}>
                    <Button type="submit" variant="contained" sx={primaryBtnSx}>Filter</Button>
                    <Button variant="outlined" sx={secondaryBtnSx} onClick={() => { reset() }}>Reset</Button>
                  </Box>
                </Grid>
              </Grid>
            </FormProvider>
          </Box>
        </Grid>
        {
          selectedRows.length > 0 && (
            <Grid item xs={12}>
              <Stack
                spacing={2}
                direction='row'
                sx={{
                  mb: 1,
                  justifyContent: 'flex-end'
                }}>
                <LoadingButton
                  loading={loading}
                  onClick={bulkCreateHandler}
                  variant='contained'
                  sx={primaryBtnSx}
                  startIcon={<CheckCircleIcon />}
                >
                  Download Labels
                </LoadingButton>
                <LoadingButton
                  loading={pushFulfilledLoading}
                  onClick={() => PushFulfilledToShopify(selectedRows, finalData, merchantId, setPushFulfilledLoading, enqueueSnackbar)}
                  variant='contained'
                  sx={primaryBtnSx}
                  startIcon={<ArrowForwardIcon />}
                >
                  Push Fulfilled
                </LoadingButton>
              </Stack>
            </Grid>
          )
        }
        <Grid item xs={12}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
            <ChannelOrderExportButton
              filename="channel_orders"
              visibleRows={finalData}
              selectedRows={finalData.filter((fd) => selectedRows.includes(fd.id))}
              selectedCount={selectedRows.length}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <ProzoDataGrid
            columns={columns}
            rows={finalData}
            sizePerPage={sizePerPage}
            setSizePerPage={setSizePerPage}
            setPage={setPage}
            page={page}
            checkboxSelection
            onSelectionModelChange={(_ids) => setSelectedRows(_ids)}
            pagination={true}
            hideFooterPagination={false}
            filterMode={"server"}
            rowCount={data?.count}
            getRowId={(row) => row.id}
          />
        </Grid>
      </Grid>

      <MUIModal
        open={orderItems ? true : false}
        title="Order Items"
        maxWidth='sm'
        handleClose={() => setOrderItems(null)}
      >
        <ProzoDataGrid
          columns={[
            { field: "sku_id", headerName: "SKU", sortable: false, flex: 1 },
            { field: "title", headerName: "Name", sortable: false, flex: 1 },
            {
              field: "selling_price",
              headerName: "Price",
              sortable: false,
              flex: 1,
            },
            {
              field: "units",
              headerName: "Quantity",
              sortable: false,
              flex: 1,
            },
            {
              field: "tax",
              headerName: "Tax(%)",
              sortable: false,
              flex: 1,
              renderCell: ({ row }) => {
                return _.sumBy(row.taxlines, function (tax) {
                  return tax.rate * 100;
                });
              },
            },
            {
              field: "dimensions",
              headerName: "Dimensions/Weight",
              sortable: false,
              width: 150,
              renderCell: ({ row }) => {
                return (
                  <Box>
                    <Typography textAlign="center" variant="body2">
                      {[row.length, row.breath, row.height].join(" x ")}
                    </Typography>
                    <Typography
                      variant="body2"
                      textAlign="center"
                      fontWeight={500}
                    >
                      {formatNumber(row.weight / 1000)}Kg
                    </Typography>
                  </Box>
                );
              },
            },
          ]}
          rows={orderItems || []}
          boxShadow={0}
          hideFooterPagination
          rowCount={orderItems?.length || 0}
          getRowId={(row) => row.id}
        />
      </MUIModal>
    </div>
  );
}
